"use client";

import { createPortal } from "react-dom";
import "./VerifyClinicModal.css";

const VerifyClinicModal = ({ isOpen, onClose, clinic, onConfirm }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const modalContent = (
    <div className="verify-clinic-modal-overlay" onClick={onClose}>
      <div className="verify-clinic-modal" onClick={(e) => e.stopPropagation()}>
        <div className="verify-clinic-modal-header">
          <button className="verify-clinic-modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div className="verify-clinic-modal-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h2 className="verify-clinic-modal-title">Verify Clinic</h2>
        </div>

        <div className="verify-clinic-modal-content">
          <p className="verify-clinic-modal-message">
            Are you sure you want to verify this clinic?
          </p>
          <div className="verify-clinic-modal-clinic-info">
            <strong>{clinic.name_en || clinic.name_ar}</strong>
            {clinic.name_ar && clinic.name_en && (
              <span className="verify-clinic-modal-clinic-name-ar"> ({clinic.name_ar})</span>
            )}
            {clinic.registration_number && (
              <div className="verify-clinic-modal-clinic-id">
                Registration: {clinic.registration_number}
              </div>
            )}
          </div>
          <p className="verify-clinic-modal-warning">
            Once verified, this clinic will be visible to all users and can accept appointments.
          </p>
        </div>

        <div className="verify-clinic-modal-actions">
          <button
            className="verify-clinic-modal-btn verify-clinic-modal-btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="verify-clinic-modal-btn verify-clinic-modal-btn-confirm"
            onClick={handleConfirm}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            Verify Clinic
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default VerifyClinicModal;

